import fetchSettings from '../Services/fetchSettings'

export default () => (dispatch) => {

  dispatch(fetchSettings())

}
